export const BCHANNEL_ADMIN_SLACK_USER_IDS = ["U078PH0GBEH"] as const;

export function isBchannelAdmin(slackUserId: string) {
  return (BCHANNEL_ADMIN_SLACK_USER_IDS as readonly string[]).includes(slackUserId);
}
